@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
  margin-bottom: $spacing-s;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.subtitle {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: center;
  padding-left: $spacing-l;
  padding-right: $spacing-l;
  padding-bottom: $spacing-m;
}

.description {
  font-size: $fontSize-s;
  font-weight: normal;
  text-align: center;
  padding-left: $spacing-l;
  padding-right: $spacing-l;
}
